import { formatPrice, formatPricePerHour, formatPricePerSession } from '@front/common/src/utils/formatting';

import { PromotionPrice, Price } from '../types/prices';

export const getFormattedPrice = (hasDuration: boolean, price?: Price) =>
  hasDuration ? formatPrice(price?.price) : formatPricePerHour(price?.hourly_price);

export const getFormattedPriceForMultiple = (hasDuration: boolean, price?: Price) =>
  hasDuration ? formatPricePerSession(price?.price) : formatPricePerHour(price?.hourly_price);

export const getFormattedPromotion = (hasDuration: boolean, promotion?: PromotionPrice) => {
  const showPromotionPerHour = promotion?.calculation_type === 'per_hour' && !hasDuration;
  return showPromotionPerHour ? formatPricePerHour(promotion?.hourly_price) : formatPrice(promotion?.price);
};
